import { DebitnoteApi } from "@/api/DebitnoteApi";
import { DebitnoteProductApi } from "@/api/DebitnoteProductApi";
import { InvoiceApi } from "@/api/InvoiceApi";
import { DEBITNOTE_ROOT_NAME, buildNoteImportDefinition } from "./noteImport";

/** Todo lo que el asistente de carga necesita saber de las notas de debito electronicas. */
export const debitnoteImportDefinition = buildNoteImportDefinition({
    documentType: "Debitnote",
    sequenceTypeCode: "02",
    rootName: DEBITNOTE_ROOT_NAME,

    ui: {
        title: "Cargar Notas de Debito XML",
        backUrl: "/user/debitnotes",
        doneActionTitle: "Ir a la lista de notas de debito",
        entityPlural: "notas de debito",
        fileHelpText:
            "Seleccione el XML de una nota de debito electronica, o un archivo ZIP con varias. Las notas se cargan tal como fueron emitidas: conservan su consecutivo y su clave de Hacienda, y no se vuelven a enviar.",
        reviewHelpText:
            "Cada nota tiene que quedar ligada a una factura ya cargada en el sistema. Las que no encuentren su factura no se cargan: cargue primero esa factura y vuelva a intentarlo.",
        confirmHelpText:
            "La carga no modifica existencias ni consume consecutivos, y no altera la factura referenciada.",
        doneHelpText:
            "El listado de notas de debito se alimenta del buscador, que se actualiza unos segundos despues de la carga.",
    },

    loadExistingKeys: () => DebitnoteApi.fetchAllDocumentKeys(),

    // `applied` marca la nota que ya fue aplicada a una factura; una nota historica entra sin
    // aplicar, igual que cuando se emite.
    extraHeader: () => ({ applied: false }),

    invalidateCaches: async () => {
        await DebitnoteApi.invalidateAllByTenant();
        DebitnoteApi.clearCache();
        await DebitnoteProductApi.invalidateAllByTenant();
        await InvoiceApi.invalidateAllByTenant();
        InvoiceApi.clearCache();
    },
});

export default debitnoteImportDefinition;
